import { DomainInitPayload, Identity } from '@sxm-de/dev-kits/web-sdk/types';

import { getIdentity } from '@sxm-de/dev-kits/web-sdk/domains/identity';

export type GetIdentityFn = () => Promise<Identity>;

export function initGetIdentityFn({
    dependencies,
}: DomainInitPayload): GetIdentityFn {
    const { appEventSdk } = dependencies;
    return async () => {
        try {
            const identity = await getIdentity(dependencies);
            appEventSdk.trackEvent({
                event: 'customer-info',
                customerInfo: {
                    email: identity?.handle?.emailAddress,
                    accountNumber: identity?.identityId,
                },
            });
            return identity;
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
